import * as z from "zod/v4";
import {
  BillOfMaterialsListItem,
  BillOfMaterialsStatus,
} from "./bill-of-materials-types";

const GetBillOfMaterialsListInput_ = z.object({
  status: BillOfMaterialsStatus.optional(),
});
export const GetBillOfMaterialsListInput: z.ZodType<GetBillOfMaterialsListInput> =
  GetBillOfMaterialsListInput_;
export interface GetBillOfMaterialsListInput
  extends z.infer<typeof GetBillOfMaterialsListInput_> {}

export const getBillOfMaterialsList = {
  name: "getBillOfMaterialsList" as const,
  input: GetBillOfMaterialsListInput,
  output: z.object({ items: z.array(BillOfMaterialsListItem) }),
};
